import Component from "../core/Component";
import support from "../utils/BrowserSupport";
import enquire from "enquire.js";
import { queries } from "../core/config";

export const STATES = {
   ACTIVE: "is-active",
};

const SPEED = 9000;

export default class Accordion extends Component {
   current = 0;
   currentTime = 0;
   running = false;

   loadingStarted = null;

   constructor(element) {
      super(element);

      this.ref = {
         items: [],
         toggles: [],
         contents: [],
      };

      if (this.element.dataset.options) {
         const options = JSON.parse(this.element.dataset.options) || {};

         this.options = {
            ...this.options,
            ...options,
         };
      }
      this.isDesktop = false;
      this.onceOpenned = false;

      this.enquireHandler = {
         match: () => {
            this.isDesktop = true;
         },
         unmatch: () => {
            this.isDesktop = false;
         },
      };
   }

   prepare() {
      window.addEventListener("resize", this.resizer);
      enquire.register(queries.largeUp, this.enquireHandler);
      // this.ref.contents.forEach(content => content.addEventListener(support.transitionEnd, ::this.handleContentTransitionEnd))

      this.element.addEventListener("open", (e) => {
         this.open(e.detail);
      });
      if (!this.isDesktop) {
         // open first
         this.open(0);
      }
      if (this.isDesktop) {
         this.ref.toggles.forEach((toggle) => toggle.addEventListener("click", ::this.handleToggleClick));
         this.ref.items.forEach((item, index) => this.close(index, true));
         this.openFirst();
         this.element.addEventListener("enteredView", () => {

            this.start();
            this.onceOpenned = true;
         });
         this.element.addEventListener("leftView", this.pause.bind(this));
      }
   }

   destroy() {
      enquire.unregister(queries.mediumUp, this.enquireHandler);
   }

   openFirst() {
      if (!this.onceOpenned) this.open(0);
   }

   handleToggleClick(event) {
      if (this.isDesktop) {
         event.preventDefault();

         const index = this.ref.toggles.indexOf(event.currentTarget);

		 console.log(index);

         this.toggle(index);
         // stop when clicked
         this.pause();
         // reset timer line
         this.ref.items[this.current].querySelector(".Accord-line").removeAttribute("style")
      }
   }

   toggle(itemIndex) {
      this.open(itemIndex);
      this.scrollCenter();
   }

   open(itemIndex) {
      this.current = itemIndex;
      const item = this.ref.items[itemIndex];
      const content = this.ref.contents[itemIndex];
      item.classList.add(STATES.ACTIVE);
      this.currentTime = 0;

      content.style.height = `${content.scrollHeight}px`;

      this.ref.items.forEach((item, index) => {
         if (index !== itemIndex) {
            this.close(index);
         }
      });

      this.getElement().dispatchEvent(new CustomEvent("itemOpened", { detail: itemIndex }));
   }

   close(itemIndex, force = false) {
      if (force || this.ref.items[itemIndex].classList.contains(STATES.ACTIVE)) {
         this.ref.items[itemIndex].classList.remove(STATES.ACTIVE);
         if (this.isDesktop) {
            this.ref.contents[itemIndex].style.height = "0px";
         } else {
            this.ref.contents[itemIndex].removeAttribute("style");
         }
      }
   }

   scrollCenter() {
      let element = document.querySelector(".AccordionSlider");
      let rec = element.getBoundingClientRect();
      rec = rec.top + window.scrollY - 80;

      window.scrollTo({
         top: rec,
         behavior: "smooth",
      });
   }

   next() {
      let itemToOpen = this.current + 1;

      if (itemToOpen >= this.ref.items.length) {
         itemToOpen = 0;
      }

      this.open(itemToOpen);
   }

   updateProgressBar(time) {
      const progressBar = this.ref.items[this.current].querySelector(".Accord-line")
      if (this.loadingStarted === null) {
         this.loadingStarted = time;
      }
      if (this.isDesktop && this.running) {
         this.currentTime += time - this.loadingStarted;
         let barWidth = this.currentTime / SPEED;
         if (barWidth > 1) {
            this.next();
         }

         if(barWidth > 0.01) progressBar.style.background = "#6835d1";
         progressBar.style.width = "calc((60px + 100%) * " + barWidth + ")";
         this.loadingStarted = time;
         window.requestAnimationFrame(this.updateProgressBar.bind(this));
      }
      if (!this.running) {
         this.loadingStarted = null;
      }
   }

   start() {
      this.running = true;
      window.requestAnimationFrame(this.updateProgressBar.bind(this));
   }

   pause() {
      this.running = false;
   }

   resizer = () => {
      if (window.innerWidth >= 1024 && this.onceOpenned === false) {
         this.prepare();
      }
   };
}
